import React from 'react';
import { Box, Container, Button, Typography } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { useNavigate } from 'react-router-dom';

export default function GetInTouch() {
    const navigate = useNavigate();

    return (
        <Box sx={{ bgcolor: '#0a0a0a', py: 8, borderTop: '1px solid #222' }}>
            <Container maxWidth="lg">
                <Box sx={{
                    bgcolor: '#18181b',
                    borderRadius: '16px',
                    p: { xs: 4, md: 6 },
                    border: '1px solid #333',
                    display: 'flex',
                    flexDirection: { xs: 'column', md: 'row' },
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: 3,
                }}>
                    <Box>
                        <Typography variant="h4" fontWeight="bold" color="white" gutterBottom>
                            Join the EvolveX Community
                        </Typography>
                        <Typography variant="body1" color="#a1a1aa">
                            Explore docs, share agent strategies, and collaborate on living-system research.
                        </Typography>
                    </Box>

                    <Button
                        variant="contained"
                        size="large"
                        endIcon={<ArrowForwardIcon />}
                        onClick={() => navigate('/contact')}
                        sx={{
                            bgcolor: '#2cbb5d',
                            color: 'black',
                            fontWeight: 'bold',
                            textTransform: 'none',
                            px: 4,
                            '&:hover': { bgcolor: '#249a4d' },
                        }}
                    >
                        Contact Us
                    </Button>
                </Box>
            </Container>
        </Box>
    );
}
